export default class EventoCreateEventoController {
  constructor($q, $state, $scope, AuthenticationService, UIService, EventoService, Evento, EventoOrganizacao, EventoTipo, Abrangencia, Papel, Investigador, Pais, Impacto, ImpactoOds, Ods) {
    this.$q = $q;
    this.state = $state;
    this.$scope = $scope;
    this.UI = UIService;
    this.user = AuthenticationService.getUser();
    this.EventoService = EventoService;
    this.loaded = false;

    this.Evento = Evento;
    this.EventoOrganizacao = EventoOrganizacao;
    this.EventoTipo = EventoTipo;
    this.Abrangencia = Abrangencia;
    this.Papel = Papel;
    this.Investigador = Investigador;
    this.Pais = Pais;
    this.Impacto = Impacto;
    this.ImpactoOds = ImpactoOds;
    this.Ods = Ods;
    this.simnao = [{ name: "Sim", value: 1 }, { name: "Não", value: 0 }];
    this.eventosTipo = null;
    this.abrangencias = null;
    this.papeis = null;
    this.investigadores = null;

    this.emptyData = {
      form: 1,
      details: {},
      impacto: {ods: []},

      organizacao: [],
      auxTipo: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxAbrangencia: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxPapel: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInvestigador: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxPublicado: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxIncludeDiscussion: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxInvolvingCivilSociety: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxPromotingTeamBuilding: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},

      auxImpactoAmbiental: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoEconomico: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoSocial: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}},
      auxImpactoPolicyInfluence: {selected: undefined, infiniteScroll: {numToAdd: 20, currentItems: 20}}
    };

    this.year = moment().format('YYYY');

    // Load data to fill ui-selects
    this.loadAuxData();

    $scope.$watch(() => {
      return this.data;
    }, (val) => {
      if (angular.isDefined(val)) {
        localStorage.setItem('ISR_SGI_EventoNewForm', JSON.stringify(val));
      }
    }, true);
  }

  loadAuxData = () => {
    this.EventoTipo.find({}).$promise.then((eventosTipo) => {
      this.eventosTipo = eventosTipo;
      this.Abrangencia.find({}).$promise.then((abrangencias) => {
        this.abrangencias = abrangencias;
        this.Papel.find({}).$promise.then((papeis) => {
          this.papeis = papeis;
          this.Investigador.find({}).$promise.then((investigadores) => {
            investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
            this.investigadores = investigadores;
            this.loadDataFromStorage();
            this.loaded = true;
          }).catch(err => {
            console.log(err);
            this.UI.addToast("Erro ao carregar investigadores. Verifique a sua ligação");
            this.state.go('app.evento.list');
          });
        }).catch(err => {
          console.log(err);
          this.UI.addToast("Erro ao carregar papéis. Verifique a sua ligação");
          this.state.go('app.evento.list');
        });
      }).catch(err => {
        console.log(err);
        this.UI.addToast("Erro ao carregar abrangências. Verifique a sua ligação");
        this.state.go('app.evento.list');
      });
    }).catch(err => {
      console.log(err);
      this.UI.addToast("Erro ao carregar tipos de evento. Verifique a sua ligação");
      this.state.go('app.evento.list');
    });
  };


  // Infinite Scroll magic
  addMoreItems = (infiniteScroll) => {
    infiniteScroll.currentItems += infiniteScroll.numToAdd;
  };

  loadDataFromStorage = () => {
    if (localStorage.getItem('ISR_SGI_EventoNewForm')) {
      let storageData = JSON.parse(localStorage.getItem('ISR_SGI_EventoNewForm'));
      // Only use what is required
      this.data = {};
      if (storageData.form) this.data.form = storageData.form; else this.data.form = angular.copy(this.emptyData.form);
      if (storageData.details) this.data.details = storageData.details; else this.data.details = angular.copy(this.emptyData.details);
      if (storageData.impacto) this.data.impacto = storageData.impacto; else this.data.impacto = angular.copy(this.emptyData.impacto);

      if (storageData.organizacao) this.data.organizacao = storageData.organizacao; else this.data.organizacao = angular.copy(this.emptyData.organizacao);

      if (storageData.auxTipo) this.data.auxTipo = storageData.auxTipo; else this.data.auxTipo = angular.copy(this.emptyData.auxTipo);
      if (storageData.auxAbrangencia) this.data.auxAbrangencia = storageData.auxAbrangencia; else this.data.auxAbrangencia = angular.copy(this.emptyData.auxAbrangencia);
      if (storageData.auxPapel) this.data.auxPapel = storageData.auxPapel; else this.data.auxPapel = angular.copy(this.emptyData.auxPapel);
      if (storageData.auxInvestigador) this.data.auxInvestigador = storageData.auxInvestigador; else this.data.auxInvestigador = angular.copy(this.emptyData.auxInvestigador);

      if (storageData.auxPublicado) this.data.auxPublicado = storageData.auxPublicado; else this.data.auxPublicado = angular.copy(this.emptyData.auxPublicado);
      if (storageData.auxIncludeDiscussion) this.data.auxIncludeDiscussion = storageData.auxIncludeDiscussion; else this.data.auxIncludeDiscussion = angular.copy(this.emptyData.auxIncludeDiscussion);
      if (storageData.auxInvolvingCivilSociety) this.data.auxInvolvingCivilSociety = storageData.auxInvolvingCivilSociety; else this.data.auxInvolvingCivilSociety = angular.copy(this.emptyData.auxInvolvingCivilSociety);
      if (storageData.auxPromotingTeamBuilding) this.data.auxPromotingTeamBuilding = storageData.auxPromotingTeamBuilding; else this.data.auxPromotingTeamBuilding = angular.copy(this.emptyData.auxPromotingTeamBuilding);

      if (storageData.auxImpactoAmbiental) this.data.auxImpactoAmbiental = storageData.auxImpactoAmbiental; else this.data.auxImpactoAmbiental = angular.copy(this.emptyData.auxImpactoAmbiental);
      if (storageData.auxImpactoEconomico) this.data.auxImpactoEconomico = storageData.auxImpactoEconomico; else this.data.auxImpactoEconomico = angular.copy(this.emptyData.auxImpactoEconomico);
      if (storageData.auxImpactoSocial) this.data.auxImpactoSocial = storageData.auxImpactoSocial; else this.data.auxImpactoSocial = angular.copy(this.emptyData.auxImpactoSocial);
      if (storageData.auxImpactoPolicyInfluence) this.data.auxImpactoPolicyInfluence = storageData.auxImpactoPolicyInfluence; else this.data.auxImpactoPolicyInfluence = angular.copy(this.emptyData.auxImpactoPolicyInfluence);
    } else {
      this.data = angular.copy(this.emptyData);
    }
    this.state.transitionTo('app.evento.new.' + this.data.form);
  };

  setForm = num => {
    this.data.form = num;
    this.state.transitionTo('app.evento.new.' + this.data.form);
  };

  cleanForm = () => {
    // Clean filled data
    this.data = angular.copy(this.emptyData);
    this.state.transitionTo('app.evento.new.' + this.data.form);
  };

  submit = () => {
    this.isValid().then(() => {
      this.loaded = false;
      // Create Evento and related data
      this.data.details.id = 0;
      this.data.details.eventoTipoId = this.data.auxTipo.selected.id;
      this.data.details.abrangenciaId = this.data.auxAbrangencia.selected.id;
      this.data.details.papelId = this.data.auxPapel.selected.id;
      this.data.details.responsavelId = this.data.auxInvestigador.selected.id;

      this.data.details.publicado = this.data.auxPublicado.selected.value;
      this.data.details.includeDiscussion = this.data.auxIncludeDiscussion.selected.value;
      this.data.details.involvingCivilSociety = this.data.auxInvolvingCivilSociety.selected.value;
      this.data.details.promotingTeamBuilding = this.data.auxPromotingTeamBuilding.selected.value;

      this.data.details.criadoPorId = this.user.id;
      this.data.details.dataCriacao = moment().format();
      this.data.details.atualizadoPorId = this.user.id;
      this.data.details.atualizadoa = moment().format();

      this.Evento.create(this.data.details).$promise.then((evento) => {

        // Create all Organização
        let deferOrganizacao = this.$q.defer();
        this.EventoService.createMultipleData(this.EventoOrganizacao, this.data.organizacao, evento.id, 'eventoId').then((x) => {
          deferOrganizacao.resolve({ok: true});
        }).catch(err => {
          deferOrganizacao.resolve({ok: false, output: 'Organização'});
        });

        // Save Impacto
        let deferImpacto = this.$q.defer();
        this.saveImpacto(this.data.impacto, evento, this.Evento).then(x => {
          deferImpacto.resolve({ok: true});
        }).catch(err => {
          deferImpacto.resolve(err); // Resolve data is solved inside since it's multi-answer
        });

        let promises = [deferOrganizacao.promise, deferImpacto.promise];

        // After all multiple data information is created/settled
        this.$q.all(promises).then((res) => {
          this.UI.addToast("Evento criado com sucesso");

          localStorage.removeItem('ISR_SGI_EventoNewForm');

          let error = this.createdMultipleDataOk(res);
          if (error) {
            let errorMessage = "Evento criado, mas ocorreram erros a inserir os seguintes dados: " + error + ". Por favor verifique e adicione-os manualmente";
            alert = this.UI.showAlert(errorMessage);
            alert.finally(() => {
              // Redirect to details view so it can be filled
              this.state.go('app.evento.details', {id: evento.id});
            });
          } else {
            this.state.go('app.evento.list');
          }
        }).catch(err => { // Should never happen, since resolving everything...
          console.log(err);
          localStorage.removeItem('ISR_SGI_EventoNewForm');
          alert = this.UI.showAlert("Evento criado, mas ocorreram erros a inserir alguns dados. Por favor verifique e adicione-os manualmente");
          alert.finally(() => {
            // Redirect to details view so it can be filled
            this.state.go('app.evento.details', {id: evento.id});
          });
        });
      }).catch((error) => {
        console.log(error);
        this.UI.showAlert("Erro ao criar evento. Verifique a ligação");
        this.loaded = true;
      });
    }).catch((x) => {
      // Nothing to do. Just fix values and resubmit...
    });
  };


  // Function called when changing Sim/Não
  // Clear <variable>Text if it becomes Não (assumes all variables have a Text field too)
  toggleOptionalData = (auxData, label) => {
    let labelText = label + 'Text';
    this.data.details[label] = auxData.selected.value;
    if (auxData.selected.value === 0) { // It was disabled, clear text
      this.data.details[labelText] = null;
    } else { // Do nothing
    }
  };

  // Check if there was an error adding multiple data, and return a string with the bad inserted data
  createdMultipleDataOk = (res) => {
    let output = '';
    if (res && res.length > 0) {
      res.forEach(r => {
        if (!r.ok) output += r.output + ", ";
      });
      // If there's data, remove trailing ", "
      if (output.length > 0)
        return output.slice(0, -2);
    }
    return output.length === 0 ? null : output;
  };


  isValid = () => {
    let validDefer = this.$q.defer();
    let v = true;

    // Check if evento data is well defined
    // Designação
    if (v && (!this.data.details.designacao || this.data.details.designacao.length === 0)) {
      this.UI.addToast("Designação / Curso do Orientando não preenchido");
      v = false;
      validDefer.reject();
    }

    // Slug
    if (v && (!this.EventoService.isValidSlug(this.data.details.slug))) {
      this.UI.addToast("Slug inválido, use apenas letras minúsculas, números e hífenes, sem espaços nem acentos.");
      v = false;
      validDefer.reject();
    }

    // Local
    if (v && (!this.data.details.local || this.data.details.local.length === 0)) {
      this.UI.addToast("Local não preenchido");
      v = false;
      validDefer.reject();
    }

    // Ano
    if (v && (isNaN(this.data.details.ano))) {
      this.UI.addToast("Ano não preenchido");
      v = false;
      validDefer.reject();
    }

    // Publicado?
    if (v && (!this.data.auxPublicado || !this.data.auxPublicado.selected)) {
      this.UI.addToast("Para publicação no frontend - valor inválido");
      v = false;
      validDefer.reject();
    }

    // Boolean data and mandatory fields if so
    if (v && (this.data.details.includeDiscussion && (!this.data.details.includeDiscussionText || this.data.details.includeDiscussionText.length === 0))) {
      this.UI.addToast("Texto adicional 'Event include discussion...' não preenchido");
      v = false;
      validDefer.reject();
    }
    if (v && (this.data.details.involvingCivilSociety && (!this.data.details.involvingCivilSocietyText || this.data.details.involvingCivilSocietyText.length === 0))) {
      this.UI.addToast("Texto adicional 'Event involving civil...' não preenchido");
      v = false;
      validDefer.reject();
    }
    if (v && (this.data.details.promotingTeamBuilding && (!this.data.details.promotingTeamBuildingText || this.data.details.promotingTeamBuildingText.length === 0))) {
      this.UI.addToast("Texto adicional 'Event promoting team...' não preenchido");
      v = false;
      validDefer.reject();
    }

    // Tipo de Evento
    if (v && (!this.data.auxTipo || !this.data.auxTipo.selected)) {
      this.UI.addToast("Tipo de Evento inválida");
      v = false;
      validDefer.reject();
    }

    // Abrangência
    if (v && (!this.data.auxAbrangencia || !this.data.auxAbrangencia.selected)) {
      this.UI.addToast("Abrangência inválida");
      v = false;
      validDefer.reject();
    }

    // Papel
    if (v && (!this.data.auxPapel || !this.data.auxPapel.selected)) {
      this.UI.addToast("Papel inválido");
      v = false;
      validDefer.reject();
    }

    // Responsável
    if (v && (!this.data.auxInvestigador || !this.data.auxInvestigador.selected)) {
      this.UI.addToast("Responsável ISR inválido");
      v = false;
      validDefer.reject();
    }

    // Mandatory multiple data
    if (v && (this.data.organizacao.length === 0)) {
      this.UI.addToast("Organização não preenchida");
      v = false;
      validDefer.reject();
    }

    // Check if data is unique for multiple data
    // Organização
    let investigadores = this.data.organizacao.map(x => x.investigadorId);
    let investigadoresRepetidos = investigadores.filter((x, i) => investigadores.indexOf(x) !== i);
    if (v && investigadoresRepetidos.length > 0) {
      this.UI.addToast("Membros da organização repetidos");
      v = false;
      validDefer.reject();
    }

    // Only validate multidata if all static data is valid, otherwise no point first
    if (v) {
      // VALIDATE ASYNC DATA
      let idData = [];

      // If slug is filled, we need to check if it exists already too
      idData.push({
        field: 'slug',
        value: this.data.details.slug,
        model: this.Evento,
        resolveOnExist: false,
        error: "Já existe este slug associado a outro evento"
      });

      // Add multi async data to verify
      this.data.organizacao.forEach(x => {
        idData.push({
          field: 'id',
          value: x.investigadorId,
          model: this.Investigador,
          resolveOnExist: true, // It's resolved if it finds one
          error: "Investigador inexistente"
        });
      });

      let wait = this.UI.showWaiting();
      // Verify all the async data
      this.EventoService.validateMultiData(idData).then(x => {

        // Verify impactos
        this.verifyImpactos(this.data.impacto).then(y => {
          wait.close();
          validDefer.resolve();
        }).catch(() => {
          wait.close();
          validDefer.reject();
        });

      }).catch(() => {
        wait.close();
        validDefer.reject();
      });
    }
    return validDefer.promise;
  };


  // MULTIPLE DATA CRUDs

  // Adicionar um novo investigador para evento
  addOrganizador = () => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.organizacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.organizador = {};
          $scope.label = "Adicionar Membro de Organização";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: undefined,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.organizador) {
          let item = angular.copy(ok.organizador);
          item.investigadorId = ok.auxInvestigador.selected.id;
          item.investigador = angular.copy(ok.auxInvestigador.selected);

          this.data.organizacao.push(item);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para organização. Verifique a sua ligação");
    });
  };

  // Edita informação de organizacao para evento
  editOrganizador = (x) => {
    let wait = this.UI.showWaiting();
    this.Investigador.find({}).$promise.then((investigadores) => {
      investigadores.sort((a, b) => a.nome.localeCompare(b.nome));
      wait.close();
      let options = {
        size: 'lg',
        template: require('./edit.organizacao.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.organizador = angular.copy(x);
          $scope.label = "Editar Membro de Organização";
          $scope.investigadores = investigadores;

          $scope.auxInvestigador = {
            selected: $scope.organizador.investigador,
            infiniteScroll: {numToAdd: 20, currentItems: 20}
          };

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        if (ok.auxInvestigador && ok.organizador) {
          x.investigadorId = ok.auxInvestigador.selected.id;
          x.investigador = angular.copy(ok.auxInvestigador.selected);
        }
      });
    }).catch((error) => {
      wait.close();
      console.log(error);
      this.UI.addToast("Não foi possível ler investigadores para evento. Verifique a sua ligação");
    });
  };

  // Remove Organizador com índice index
  removeOrganizador = (index) => {
    if (index < this.data.organizacao.length) {
      this.data.organizacao.splice(index, 1);
    }
  };

  // Impactos
  // Get data to be used in impacto edit modal
  getImpactoData = (tipo) => {
    let wait;
    let defer = this.$q.defer();
    switch(tipo) {
      case 'Ambiental':
        defer.resolve(null);
        break;
      case 'Económico':
        defer.resolve(null);
        break;
      case 'ODS':
        wait = this.UI.showWaiting();
        this.Ods.find({}).$promise.then((ods) => {
          wait.close();
          defer.resolve(ods);
        }).catch((error) => {
          wait.close();
          console.log(error);
          defer.reject(error);
        });
        break;
      case 'Social':
        defer.resolve(null);
        break;
    }
    return defer.promise;
  };

  // Edit/add impacto for tipo
  editImpacto = (tipo) => {
    this.getImpactoData(tipo).then(externalData => {
      let options = {
        size: 'lg',
        template: require('./impacto.dialog.html'),
        controller: ['$scope', '$dialog', ($scope, $dialog) => {
          $scope.tipo = tipo;
          $scope.label = "Editar Impacto " + tipo;
          $scope.impacto = angular.copy(this.data.impacto);
          switch(tipo) {
            case 'Ambiental':
              $scope.simnao = this.simnao;
              $scope.auxImpactoAmbiental = angular.copy(this.data.auxImpactoAmbiental);
              break; // Nothing to do
            case 'Económico':
              $scope.simnao = this.simnao;
              $scope.auxImpactoEconomico = angular.copy(this.data.auxImpactoEconomico);
              break;
            case 'ODS':
              $scope.externalData = externalData;
              // ODS is always "add", so it always starts as empty
              $scope.auxOds = {
                selected: undefined,
                infiniteScroll: {numToAdd: 20, currentItems: 20}
              };
              break;
            case 'Social':
              $scope.simnao = this.simnao;
              $scope.auxImpactoSocial = angular.copy(this.data.auxImpactoSocial);
              break;
          }

          // Infinite Scroll magic
          $scope.addMoreItems = (infiniteScroll) => {
            infiniteScroll.currentItems += infiniteScroll.numToAdd;
          };

          $scope.ok = () => {
            $dialog.close($scope);
          };

          $scope.cancel = () => {
            $dialog.dismiss('cancel');
          };
        }]
      };
      let dialogEdit = this.UI.showDialog(options);
      dialogEdit.then(ok => {
        switch(tipo) {
          case 'Ambiental':
            if(ok.auxImpactoAmbiental && ok.auxImpactoAmbiental.selected.value) { // Has "Yes" selected
              this.data.auxImpactoAmbiental = angular.copy(ok.auxImpactoAmbiental);
              this.data.impacto.ambiental = ok.impacto.ambiental;
              this.UI.addToast("Impacto ambiental atualizado");
            } else { // No ambiental data is defined, delete it
              if (this.data.impacto.ambiental) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoAmbiental.selected = undefined;
                delete this.data.impacto.ambiental;
                this.UI.addToast("Impacto ambiental eliminado");
              }
            }
            break;
          case 'Económico':
            if(ok.auxImpactoEconomico && ok.auxImpactoEconomico.selected.value) { // Has "Yes" selected
              this.data.auxImpactoEconomico = angular.copy(ok.auxImpactoEconomico);
              this.data.impacto.economico = ok.impacto.economico;
              this.UI.addToast("Impacto económico atualizado");
            } else { // No economico data is defined, delete it
              if (this.data.impacto.economico) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoEconomico.selected = undefined;
                delete this.data.impacto.economico;
                this.UI.addToast("Impacto económico eliminado");
              }
            }
            break;
          case 'ODS':
            // Check repeats - Placed here instead of isValid() so it's easier to port
            let usedOds = this.data.impacto.ods.map(x => x.odsId);
            usedOds.push(ok.auxOds.selected.id);
            let odsRepetidos = usedOds.filter((x, i) => usedOds.indexOf(x) !== i);
            if (odsRepetidos.length > 0) {
              this.UI.addToast("ODS já adicionada");
            } else { // We can add it
              this.data.impacto.ods.push({
                odsId: ok.auxOds.selected.id,
                ods: { id: ok.auxOds.selected.id, designacao: ok.auxOds.selected.designacao }
              });
              this.UI.addToast("ODS adicionado com sucesso");
            }
            break;
          case 'Social':
            if(ok.auxImpactoSocial && ok.auxImpactoSocial.selected.value) { // Has "Yes" selected
              this.data.auxImpactoSocial = angular.copy(ok.auxImpactoSocial);
              this.data.impacto.social = ok.impacto.social;
              this.UI.addToast("Impacto social atualizado");
            } else { // No social data is defined, delete it
              if (this.data.impacto.social) { // If it's filled, delete it, otherwise don't bother
                this.data.auxImpactoSocial.selected = undefined;
                delete this.data.impacto.social;
                this.UI.addToast("Impacto social eliminado");
              }
            }
            break;
        }
      });
    }).catch(error => {
      console.log(error);
      this.UI.addToast("Não foi possível ler dados para edição. Verifique a sua ligação");
    });
  };

  // Function called when changing Sim/Não
  // Clear text if it becomes Não
  togglePolicyInfluence = () => {
    if (this.data.auxImpactoPolicyInfluence) {
      if (this.data.auxImpactoPolicyInfluence.selected.value === 0) { // It was disabled, clear text
        this.data.impacto.policyInfluence = null;
      } else { // Do nothing
      }
    }
  };

  // Returns true or false if impactos data is ok to set to database
  verifyImpactos = (impacto) => {
    let defer = this.$q.defer();
    // Ambiental - Nothing to check
    // Social - Nothing to check
    // Económico - Nothing to check

    // ODS - Verifica ODSs individuais
    let deferOds = this.$q.defer();
    if (impacto.ods && impacto.ods.length > 0) {
      let odsTasks = [];
      for (let i = 0; i < impacto.ods.length; i++) {
        let o = this.$q.defer();

        this.EventoService.fieldValueExists('id', impacto.ods[i].id, this.Ods).then((exists) => {
          o.resolve(exists);
        }).catch(error => {
          o.reject(error);
        });
        odsTasks.push(o.promise);
      }

      this.$q.all(odsTasks).then(x => {
        deferOds.resolve(true);
      }).catch(error => {
        deferOds.reject(error);
      });
    } else {
      deferOds.resolve(true);
    }

    this.$q.all([deferOds.promise]).then(x => {
      defer.resolve();
    }).catch(error => {
      this.UI.addToast("Não foi possível verificar dados de impactos. Verifique a ligação");
      defer.reject(error);
    });

    return defer.promise;
  };

  // Save impacto data to database, update object with impactoId of type Model
  saveImpacto = (imp, object, Model) => {
    let defer = this.$q.defer();
    let newImpacto = {
      id: 0,
      ambiental: imp.ambiental || null,
      economico: imp.economico || null,
      social: imp.social || null,
      observacoes: imp.observacoes || null,
      policyInfluence: imp.policyInfluence || null,
      criadoPorId: this.user.id,
      dataCriacao: moment().format()
    };

    this.Impacto.create(newImpacto).$promise.then((impacto) => {
      // Save impactoId to base object for reference
      object.impactoId = impacto.id;
      Model.upsert(object).$promise.then((res) => {
        defer.resolve();
        // Create all ODS
        this.EventoService.createMultipleData(this.ImpactoOds, imp.ods, impacto.id, 'impactoId').then(x => {
          defer.resolve();
        }).catch(error => {
          console.log(error);
          defer.reject({ok: false, output: 'Impacto - ODS'});
        });
      }).catch((error) => {
        console.log(error);
        defer.reject({ok: false, output: 'Ligação a Impacto'});
      });
    }).catch((error) => {
      console.log(error);
      defer.reject({ok: false, output: 'Impacto'});
    });

    return defer.promise;
  };

  removeImpacto = (tipo, index) => {
    switch(tipo) {
      case 'Ambiental':
        this.data.auxImpactoAmbiental.selected = undefined;
        delete this.data.impacto.ambiental;
        this.UI.addToast("Impacto ambiental eliminado");
        break;
      case 'Económico':
        this.data.auxImpactoEconomico.selected = undefined;
        delete this.data.impacto.economico;
        this.UI.addToast("Impacto económico eliminado");
        break;
      case 'ODS':
        if (index < this.data.impacto.ods.length) {
          this.data.impacto.ods.splice(index, 1);
          this.UI.addToast("Objetivo eliminado");
        }
        break;
      case 'Social':
        this.data.auxImpactoSocial.selected = undefined;
        delete this.data.impacto.social;
        this.UI.addToast("Impacto social eliminado");
        break;
    }
  };

  updateSlug = () => {
    this.data.details.slug = this.EventoService.stringToSlug(this.data.details.designacao);
  };

}

EventoCreateEventoController.$inject = ['$q', '$state', '$scope', 'AuthenticationService', 'UIService', 'EventoService', 'Evento', 'EventoOrganizacao', 'EventoTipo', 'Abrangencia', 'Papel', 'Investigador', 'Pais', 'Impacto', 'ImpactoOds', 'Ods'];
